import BaseResponse from "@/model/responses/BaseResponse";

class AuthResponse extends BaseResponse {
  static login = {
    customerId: null,
    customerFirstName: null,
    customerLastName: null,
    customerCountry: null,
    customerEmail: null,
    customerPhoneNumber: null,
    customerCountryCode: null,
    customerCreatedAt: null,
    customerUpdatedAt: null,
    customerLoginAttempt: null,
    customerStatus: null,
    customerDisplayPicture: null,
    customerCoverPhoto: null,
    customerTimezone: null,
    userRole: null,
    professional: {
      professionalId: null,
      professionalCustomerId: null,
      professionalFollowers: null,
      professionalExperienceLength: null,
      professionalExperienceLevel: null,
      professionalCategory: null,
      professionalSubCategory: null,
      professionalSummary: null,
      professionalBookingFee: null,
      professionalCreatedAt: null,
      professionalUpdatedAt: null,
      professionalStatus: null
    },
    token: null
  };
}

export default AuthResponse;
